<template>
 <div id="cloud-stage">
  <div class="header mt-5">
   <b class="text-3xl">Finalizando as configurações da sua Conexão.</b>
  </div>

  <p class="mt-5 mb-5">Necessário aguardar nesta tela a finalização do processo de ativação de chips no {{appTitle}}. Não se preocupe, a equipe irá te ajudar nessa etapa.</p>

  <div class="body mt-5">
   <div class="flex">
    <feather-icon icon="CheckIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Dentro de alguns minutos a conexão estará pronta, após siga com a conclusão.</p>
   </div>
  </div>
 </div>
</template>

<script>

export default {
 name: 'cloud-stage',
 data() {
  return {}
 },
 computed:{
  appTitle() {
   return process.env.VUE_APP_APP_TITLE || 'PedBot';
  }
 }
}

</script>

<style scoped lang="scss">

</style>